import { graphql } from "gatsby";
import parse from "html-react-parser";
import React from "react";
import { Col, Container, Row } from "reactstrap";
import { SubscribeInline } from "src/components/Email/SubscribeInline";
import SEO from "src/components/General/SEO";

export interface SpeakerSeriesProps {}

const ContinuingEducationPage: React.FunctionComponent = (pageContext: any) => {
  const { data } = pageContext;
  const { page } = data;
  const tagsToComponents = (content: string): any => {
    return parse(content, {
      // eslint-disable-next-line consistent-return
      replace: (domNode: any): any => {
        if (domNode.tagName === "subscribe") {
          return (
            <SubscribeInline
              cta={domNode.attribs.cta ? domNode.attribs.cta : null}
              body={domNode.attribs.body ? domNode.attribs.body : null}
            />
          );
        }
      },
    });
  };
  return (
    <Container className="page continuing-education">
      <SEO
        title={"Continuing Education (CE) Credits for Conferences, Workshops, & Courses"}
        description={
          "We partner with organizations to provide continuing education (CE) credits for health professionals at workshops, conferences, and trainings."
        }
        pathname={"/continuing-education/"}
      />
      <Row className="mt-3">
        <Col>
          <h1>{page.title}</h1>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <div className="entry-content">{tagsToComponents(page.content)}</div>
        </Col>
      </Row>
    </Container>
  );
};

export const pageQuery = graphql`
  {
    page: wpPage(id: { eq: "cG9zdDo2NzQ0MQ==" }) {
      id
      seo {
        title
        canonical
        metaDesc
      }
      uri
      title
      date(formatString: "LL")
      dateGmt
      modified(formatString: "LL")
      modifiedGmt
      content
    }
  }
`;

export default ContinuingEducationPage;
